export default __webpack_public_path__ + "static/media/garware-icecool.feb31aa4.jpg";